import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import InfoCard from '../components/InfoCard';
import DirectorPage from "../components/DirectorPage";
import CoursesSection from "../components/CoursesSection"; 

import './Home.css';

function HomePage() {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const navigate = useNavigate();
  

  // Array of image paths for the carousel
  const images = [
    'images/IMG-20241112-WA0039.jpg',
    'images/IMG-20241112-WA0035-modified.jpg',
    'images/news.jpg',
    'images/IMG_1810.jpg',
    'images/IMG-20241112-WA0019-modified.jpg',
    'images/IMG-20241112-WA0022-modified.jpg',
    'images/IMG-20241112-WA0016-modified.jpg',
    'images/ground.jpg'
  ];



  const handleNextImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const handlePrevImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  // Automatically advance the carousel every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000);

    // Clean up the interval on component unmount
    return () => clearInterval(interval);
  }, [images.length]);

   // The handleLearnMore function
  const handleLearnMore = (title, content, images) => {
    console.log('Navigating to details with:', { title, content, images });
    navigate('/details', {
      state: {
        title,
        content: JSON.stringify(content),
        images,
        adminView: true, // Optional: Admin view flag
      },
    });
  };


  // const handleLearnMoreCTA = () => {
  //   navigate('/about');  // Navigate to the About page when button is clicked
  // };
  return (
    <div className="homepage-container">
      <h1 className="hero-title">RDTC Singawal, Ajmer</h1>
      <h1 className="hero-title">
  <div className="sliding-text-container">
    <span className="sliding-text">
      Empowering your journey with expert driver training and cutting-edge road safety education.
    </span>
  </div>
</h1>

      <header className="hero-section">
        <div className="carousel">
          <button onClick={handlePrevImage} className="carousel-button prev">
            &#10094;
          </button>
          <img
  src={images[currentImageIndex]}
  alt="RDTC Hero"
  className={`hero-image ${currentImageIndex === 0 ? 'active' : ''}`}
/>
          <button onClick={handleNextImage} className="carousel-button next">
            &#10095;
          </button>
        </div>

      </header>
      <DirectorPage />

            {/* About Section */}
            <section className="about-section">
        <div>
          <h2>About RDTC Singawal</h2>
          <p className="text-gray-700 leading-relaxed mb-4">
          The <strong>Regional Driving Training Center (RDTC)</strong>, located in Singawal, Ajmer, has been established under the
          <strong> Ministry of Road Transport & Highways (MoRTH)</strong>, Government of India, as part of the <strong>IDTR/RDTC scheme</strong>
          within the 14th Financial Circle (2017-18 to 2020-21). 
        </p><br />
        <p className="text-gray-700 leading-relaxed mb-4">
        Approved and sanctioned by <strong>MoRTH </strong> on <strong>March 10, 2021,</strong> the <strong>RDTC Singawal</strong> stand as <strong>India's first RDTC</strong>.
        The center was successfully completed and became fully operational on <strong>March 21, 2024.</strong>
        </p><br />
        <p className="text-gray-700 leading-relaxed mb-4">
        This state-of-the-art facility is dedicated to enhancing road safety through comprehensive and professional driver training programs. 
        It aims to elevate driving standards, reduce road accidents, and contribute to safer road practices across the region, aligning with the government’s ongoing
        efforts to improve road safety nationwide.
        </p><br />
        <p className="text-gray-700 leading-relaxed mb-4">
        <strong>Vahan Chalak Kaushal Vikas Sansthan (VCKVS)</strong> has been established to oversee the construction, management, and operational activities of the <strong>Regional Driving Training Center (RDTC)</strong>. 
        The organization is composed of representatives from key stakeholders, including the<strong> Ministry of Road Transport & Highways (MoRTH), Government of India, 
        the Transport & Road Safety Department, Government of Rajasthan</strong>, and the<strong> Rajasthan Sadak Suraksha Society (RSSS)</strong>.
        </p><br />
        <p className="text-gray-700 leading-relaxed">
          VCKVS is a <strong>non-governmental organization (NGO)</strong>, duly registered under the <strong>Rajasthan Society Registration Act, 1958</strong>.
          It holds recognition under <strong>Sections 80G</strong> and <strong>12A</strong> of the <strong>Income Tax Act, 1961</strong>, and is also registered under the <strong>Trust
          Act</strong> and <strong>CSR1</strong>, ensuring full compliance with legal provisions for charitable and social welfare activities.
        </p>
        </div>
      </section>


      <div className="features-container">
        <InfoCard
          title="Experienced Instructors"
          content="Learn from certified professionals who bring years of expertise in road safety and driving."
          onLearnMore={() => navigate('/administration')}
        />

        <InfoCard
          title="Modern Infrastructure"
          content="State-of-the-art facilities for an immersive learning experience."
          onLearnMore={() => handleLearnMore(
            "Modern Infrastructure",
            "Our facilities include modern classrooms, simulation labs, and a test track designed for practical learning.",
            ['images/IMG-20241112-WA0025.jpg', 'images/IMG-20241112-WA0020-modified.jpg', 'images/IMG-20241112-WA0034.jpg', 'images/IMG-20241112-WA0022-modified.jpg', 'images/IMG-20241112-WA0017-modified.jpg', 'images/IMG-20241112-WA0023.jpg',
              'images/IMG-20241112-WA0055-modified.jpg', 'images/IMG-20241112-WA0021-modified.jpg', 'images/IMG-20241112-WA0029-modified.jpg', 'images/IMG-20241112-WA0019-modified.jpg','images/IMG_9823-modified.JPG','images/IMG-20241112-WA0026-modified.jpg']
          )}
        />

<InfoCard
  title="Government Approved"
  content="All courses are certified by the Ministry of Road Transport & Highways, GOI."
  onLearnMore={() => navigate('/GovernmentApproved')}
/>
      </div>

      
      {/* Updated Features Section */}
      <section className="features-section">
  <h2>Why Choose Us?</h2>
  <div className="sliding-text-container">
    <div className="sliding-text">
      Knowing how to drive a car is no longer a luxury; it's a necessity!
    </div>
  </div>
  <div className="why-choose-us-container">
    <div className="why-choose-us-image">
      <img src="/images/IMG-20241112-WA0017.jpg" alt="Why Choose Us" />
    </div>
    <div className="why-choose-us-content">
      <p><strong>We Help, To Pass Test & Get A License On The First Try</strong></p>
      <p>Let us be your driving force to success!</p>
      <p>Our proven methods and expert instructors are dedicated to getting you test-ready and license-certified on your very first attempt.</p>
      <p>Don't waste time or money on multiple tries. Join us and experience the thrill of hitting the road confidently with your hard-earned license in hand.</p>
      <p><strong>With a Government Approved syllabus</strong>, don’t just learn to drive. We’ll also teach you about the vehicle, its parts, and how they work.</p>
      <p>We are a government-authorized and licensed Driving Centre with modern infrastructure, affordable fees, and the best experienced driving instructors.</p>
    </div>
  </div>
</section>

  {/* Video Section */}
  <div className="video-container">
  <video
    controls
    loop
    className="homepage-video"
    // style={{ marginTop: '0px' }}
  >
    <source src="/videos/V_new.mp4" type="video/mp4" />
    Your browser does not support the video tag.
  </video>
</div>

<CoursesSection/>

{/* <section className="horizontal-layout"> */}
  <div className="horizontal-section cta">
    <h2>Join Us for a Safer Tomorrow</h2>
    <p>
      Whether you're a new driver or an experienced professional, RDTC offers tailored programs to enhance your skills. Get started with us today and be part of the road safety revolution.
    </p>
    <p>
      We believe in providing hands-on experience, and our training sessions are designed to teach you essential skills that can save lives, reduce accidents, and improve traffic safety. Our focus is on building responsible, skilled, and safe drivers.
    </p>
    <p>
      By choosing RDTC, you're investing in your safety and the safety of others. Join us today and take the first step toward a better and safer tomorrow.
    </p>
  </div>
{/* </section> */}

<div className="training-partners-section">
  <h2>We Are Training Partners</h2>
  <p>
    "We are proud to be Training Partners with esteemed organizations, including the following Sector Skill Councils:
    <strong> ASDC</strong>, <strong>LSC</strong>, <strong>NSDC</strong>, and others."
  </p>
  <div className="partner-logos">
    <a href="https://www.asdc.org.in/" target="_blank" rel="noopener noreferrer">
      <img src="/images/1656312317Logo.png...png" alt="ASDC Logo" className="partner-logo" />
    </a>
    <a href="https://lsc-india.com/" target="_blank" rel="noopener noreferrer">
    <a href="" target="_blank" rel="noopener noreferrer"></a>
    <img src="/images/Logistics-Sector-Skill-Council-Logo-2.png" alt="LSC Logo" className="partner-logo" />
    </a>
    <a href="https://dbskills.com/" target="_blank" rel="noopener noreferrer">
    <img src="/images/db-skills-logo-removebg-preview.png" alt="NSDC Logo" className="partner-logo" />
    </a>
    <a href="https://www.tuv.com/world/en/" target="_blank" rel="noopener noreferrer">
    <img src="/images/TUV_Rheinland_Logo.png" alt="TUV Logo" className="partner-logo" />
    </a>
    <a href="https://www.skillindiadigital.gov.in/" target="_blank" rel="noopener noreferrer">
    <img src="/images/Skill-Logo-2048x979.png" alt="NSDC Logo" className="partner-logo" />
    </a>
    <a href="https://www.nsdcinternational.com/" target="_blank" rel="noopener noreferrer">
    <img src="/images/NSDC-Logo-2048x979.png" alt="NSDC Logo" className="partner-logo" />
    </a>
    <a href="https://takamolholding.com/en" target="_blank" rel="noopener noreferrer">
    <img src="/images/takamul.png" alt="NSDC Logo" className="partner-logo" />
    </a>
  </div>
</div>


    </div>
  );
}

export default HomePage;

